// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__eSY4o","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3Oy4F","obliqueLine":"membershipbadge_obliqueLine__bga2n"};